import mixitup from 'mixitup';

$(() => {
  $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-1"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>');

  var timing = 200;

  $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function () {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function () {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  // Desktop nav
  $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function () {
    if ($(window).innerWidth() > 991) {
      var target = $(this).find('> ul.sub-menu');
      var width = $(target).outerWidth();

      var right_of_screen = $(window).innerWidth();
      var right_of_parent = $(this).offset().left + $(this).outerWidth();
      var right_of_element = right_of_parent + width;

      if (right_of_screen > right_of_element) {
        $(target).css('transform', 'translateX(100%)');
        $(target).css('right', '0');
      } else {
        $(target).css('transform', 'translateX(-100%)');
        $(target).css('left', '0');
      }
    }
  });

  $('.slick-banner').on('init', function () {
    var hiddenSlides = $('.slick-banner .hidden');
    if (hiddenSlides.length > 1) {
      $('.slick-banner .hidden').each(function (i, el) {
        $(el).removeClass('hidden');
      })
    } else {
      hiddenSlides.removeClass('hidden');
    }
  })

  $('.icaal-contact-form').on('success', function() {
    gtag('event', 'Submit_Contact_Form', {
      event_category: 'Form',
    })
  });

  // Slick
  $('.slick-banner').slick({
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  $('.products-slider').slick({
    dots: false,
    arrows: false,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 3,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
    ],
  });

  $('.slick-p').click(function () {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.slick-n').click(function () {
    $(this).parent().prev().slick('slickNext');
  });

  // Testimonials Slick
  $('.testimonials-slider').slick({
    dots: true,
    arrows: false,
    cssEase: 'ease-in-out',
    slidesToShow: 2,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // Mixitup
  if ($('.mix-container').length) {
    var mixer = mixitup('.mix-container');
    if (mixer) {
      console.log('mix');
    }
  }

  // Cookie Policy
  $.fn.CookieNotice = function () {
    if (!localStorage.getItem('cookie-notice-dismissed')) {
      var notice = this;
      setTimeout(function () {
        notice.addClass('active');
      }, 1000);
    }
    this.addClass('cookie-notice');
    return this
  }
  $(document).on('click', '.cookie-notice-dismiss', function () {
    localStorage.setItem('cookie-notice-dismissed', true);
    $(this).parents('.cookie-notice').removeClass('active');
  })
  $('#cookie-notice').CookieNotice();

  // Share Button
  $('.page-share').click(function () {
    if (navigator.share) {
      navigator.share({
        title: 'Share This Page',
        url: window.location,
      }).then(() => {
        console.log('Thanks for sharing!');
      })
        .catch(err => {
          console.log('Couldnt share because of', err.message);
        });
    } else {
      $('#panel-share').toggleClass('active');
      console.log('navigator.share not supported!')
    }
  });

  $('.panel-share-close').click(function () {
    $('#panel-share').removeClass('active');
  });

  // Mobile Nav
  $('#nav-primary-toggle').click(function () {
    $('.nav-primary').toggleClass('open');
    $('.nav-backdrop').toggleClass('show');
  });
});

// Landing Page Gallery Slider
$('.slick-gallery-landing').slick({
  dots: false,
  infinite: false,
  slidesToShow: 2,
  autoplay: true,
  slidesToScroll: 1,
  draggable: true,
  centerMode: false,
});

// Doors Slider
$(".new-popular-doors-slider").slick({
  centerMode: !0,
  centerPadding: "60px",
  slidesToShow: 7,
  infinite: !0,
  speed: 500,
  asNavFor: ".new-popular-doors-slider-content, .new-popular-doors-slider-colour",
  arrows: !0,
  adaptiveHeight: !0,
  draggable: !1,
  prevArrow: $(".prev-popular"),
  nextArrow: $(".next-popular"),
  responsive: [
    { breakpoint: 1500, settings: { centerMode: !0, slidesToShow: 5 } },
    { breakpoint: 992, settings: { centerMode: !0, centerPadding: "40px", slidesToShow: 3 } },
    { breakpoint: 480, settings: { centerMode: !0, centerPadding: "20px", slidesToShow: 3 } },
  ],
}),
  $(".new-popular-doors-slider-content").slick({ slidesToShow: 1, draggable: !1, fade: !0, arrows: !1, asNavFor: ".new-popular-doors-slider, .new-popular-doors-slider-colour, .acoustic-doors-slider", dots: !1 }),
  $(".new-popular-doors-slider-colour").slick({ slidesToShow: 1, draggable: !1, fade: !0, arrows: !1, dots: !1 }),
  $(".acoustic-doors-slider").slick({
    centerMode: !0,
    centerPadding: "60px",
    slidesToShow: 3,
    infinite: !0,
    speed: 500,
    asNavFor: ".new-popular-doors-slider-content",
    arrows: !0,
    adaptiveHeight: !0,
    draggable: !1,
    prevArrow: $(".prev-popular"),
    nextArrow: $(".next-popular"),
    responsive: [
      { breakpoint: 992, settings: { centerMode: !0, centerPadding: "40px", slidesToShow: 3 } },
      { breakpoint: 480, settings: { centerMode: !0, centerPadding: "20px", slidesToShow: 3 } },
    ],
  }),

  // Slider Gallery
  $('.slider-gallery').slick({
    arrows: !0,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $(".prev-slide"),
    nextArrow: $(".next-slide"),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ],
  });

// Smooth Scroll
$(function () {
  $('a[href*=#]:not([href=#])').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 10, scrollLeft: target.offset().left - 10,
        }, 1000);
        return false;
      }
    }
  });
});

// Door Slider Modal

$('a[data-toggle="modal"]').click(function (e) {
  e.preventDefault();
  $("#doorModal").show();
  $(".overlayer-modal").show();

  var target = e.target,
    handle = $(target).data("handle"),
    glazing = $(target).data("glazing"),
    style = $(target).data("style"),
    accessories = $(target).data("accessories"),
    colour = $(target).data("colour"),
    img = $(target).data("img");

  if ($('#doorModal').css('display') == "block") {
    $('#product-glazing-choice').val(glazing),
    $('#product-handle').val(handle),
    $('#product-accessories').val(accessories),
    $('#product-colour').val(colour),
    $('#product-price').val(e),
    $('#door-style-image-url').val(img),
    $('#door-style-image').attr('src', img),
    $('.glazing-info').text(glazing),
    $('.handle-info').text(handle),
    $('.colour-info').text(colour),
    $('.price-info').text(e),
    $('.accessories-info').text(accessories),
    $('.door-style-title').text(style + ' DOOR DESIGN QUOTE');
    $('#product-qq').text(style);
    $('#product-qq').val(style); //added on 17April2024
  }
});

$('.close').click(function () {
  $("#doorModal").hide();
  $(".overlayer-modal").hide();
});

$("#doorModal").on("hide", function () {
  var t = $("#quick-quote-form-new");
  t.find(".response").empty(), t.find(".submit").prop("disabled", !1), t.find("input").addClass("is-valid").removeClass("is-invalid"), t.find(".invalid-feedback").empty(), t.find(".validate-autocomplete").empty(), t[0].reset();
});

// door designer page
const designerIframe = $('.designer-iframe');
const designerIframeBtn = $('.designer-btn-iframe');
$('.designer-btn').on('click', function () {
  let designerLink = $(this).data('designer');

  // Scroll to designerIframe
  $('html, body').animate({
    scrollTop: designerIframe.offset().top - 200
  }, 500);

  if (designerIframe.attr('src') === designerLink) {
    return;
  };
  designerIframe.attr('src', designerLink);
  designerIframeBtn.attr('href', designerLink);

});

$('.image-row-slider').slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  draggable: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false
      }
    }
  ]
});


(function($) {

})(jQuery);

$(document).ready(function () {
    const doorModalForm = $('#quick-quote-form-new');
    const formEndPointAPI = 'https://api.endurancedoors.co.uk/leads';
    // const formEndPointAPI = 'https://api.endurance.test/leads';
    let postcodeResponse = $('#postcodeResponse');
    let formResponseMessage = $('.responseMessage');

    $('#first-name, #last-name, #email, #phone, #postcode').on('input', function() {
      $(this).next('.invalid-feedback').text('');
    });

    doorModalForm.submit(function (event) {
      event.preventDefault();
      
      let formData = new FormData(this);
      let postcode = formData.get("postcode");
      let firstName = formData.get("first_name");
      let lastName = formData.get("last_name");
      let email = formData.get("email");
      let phone = formData.get("phone");
      let address = formData.get("address");

      $('.input-details').each(function() {
          formData.set(`details[${$(this).attr('name')}]`, $(this).val());
      });

      // Simple front-end validation
      let isValid = true;
      if (!firstName) {
        $('#first-name').next('.invalid-feedback').text('Please enter a valid first name.');
        isValid = false;
      }
      if (!lastName) {
        $('#last-name').next('.invalid-feedback').text('Please enter a valid last name.');
        isValid = false;
      }
      if (!email) {
        $('#email').next('.invalid-feedback').text('Please enter a valid email.');
        isValid = false;
      }
      if (!phone) {
        $('#phone').next('.invalid-feedback').text('Please enter a valid phone number.');
        isValid = false;
      }
      if (!postcode) {
        $('#postcode').next('#postcodeResponse').text('Please enter a valid postcode.');
        isValid = false;
      }
      if (!address) {
        $('#address').next('.invalid-feedback').text('Please enter a valid address.');
        isValid = false;
      }
      if (!isValid) {
        return;
      }
      
      // postcode validation
      $.ajax({
          url: '//api.postcodes.io/postcodes/' + postcode,
          method: 'GET'
      }).done(function(response) {
          postcode = response.result.postcode;
          
          let dataObject = {};
          for (const [key, value]  of formData.entries()) {
            dataObject[key] = value;
          }

          $('.modal-spinner').show();

          $.ajax({
            type: "POST",
            url: formEndPointAPI,
            data: dataObject,
          }).done(function (data) {
            formResponseMessage.text('Thank you for your enquiry. We will be in touch shortly.').show();
            
            $('.modal-spinner').hide();

            setTimeout(function () {
              formResponseMessage.text('').hide();
              doorModalForm[0].reset();
            }
            , 3000);
          }).fail(function(response) {
            console.log(response);
            $('.modal-spinner').hide();
          });
  
      }).fail(function(response) {
          postcodeResponse.text('Please enter a valid UK postcode.');
          $(this).prop('disabled', false);
      });
    });
    
 });